'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
/**
 * @name - FrameCommunicator
 * @description - Multiplexing PostMessage service, to communicate between iframes
 * @example
 * import FrameCommunicator from '@bit/bit.capsule.iframe.communicator';
 *
 * const communicator = new FrameCommunicator();
 * communicator.sendMessage('lol', 'cat');
 */


var FrameCommunicator = function () {
  /**
   * @name - constructor
   * @param {Object} options
   * @param {string} options.targetFrameId
   * @param {string} options.selfFrameId
   */
  function FrameCommunicator(_ref) {
    var targetFrameId = _ref.targetFrameId,
        selfFrameId = _ref.selfFrameId,
        _ref$isDebugging = _ref.isDebugging,
        isDebugging = _ref$isDebugging === undefined ? false : _ref$isDebugging;

    _classCallCheck(this, FrameCommunicator);

    this.targetFrameId = targetFrameId;
    this.selfFrameId = selfFrameId;
    this.isDebugging = isDebugging;
    this.isAlive = true;
    this.listeners = new Set();
    if (isDebugging) this.__iframeDepth = calcIframeDepth();
  }
  /**
   * @name - destroy
   * @description - drops all listeners and stop all messages
   */


  _createClass(FrameCommunicator, [{
    key: 'destroy',
    value: function destroy() {
      if (!this.isAlive) return;
      this.isAlive = false;
      this.listeners.forEach(this.dropListener.bind(this));
    }
    /**
     * @name - sendMessage
     * @param {string} type
     * @param {any} payload
     */

  }, {
    key: 'sendMessage',
    value: function sendMessage(type, payload) {
      if (!this.isAlive) return false;

      var target = this._getTargetWindow();

      if (!target) return false; //should this be an exception?

      this.isDebugging && console.debug('>'.repeat(this.__iframeDepth), 'sending message', type, payload);
      target.postMessage({
        source: this.selfFrameId,
        type: type,
        payload: payload
      }, '*');
      return true;
    }
    /**
     * @name - onMessage
     * @param {string} eventType
     * @param {any => void} handler
     * @returns {function} listener
     */

  }, {
    key: 'onMessage',
    value: function onMessage(eventType, handler) {
      if (!this.isAlive) return false;

      if (typeof window === 'undefined') {
        throw Error('No window object. Could you be executing at Serverside?');
      }

      var targetFrameId = this.targetFrameId,
          __iframeDepth = this.__iframeDepth,
          isDebugging = this.isDebugging;

      var listener = function listener(event) {
        if (!event || !event.data) return;
        if (targetFrameId && event.data.source !== targetFrameId) return;
        var _event$data = event.data,
            type = _event$data.type,
            payload = _event$data.payload;
        if (type !== eventType) return;
        isDebugging && console.debug('<'.repeat(__iframeDepth), 'got message', type, payload);
        handler(payload);
      };

      this.listeners.add(listener);
      window.addEventListener('message', listener);
      return listener;
    }
    /**
     * @name - once
     * @description - await single message
     * @param {string} eventType
     * @example
     * communicator.once('iframeDidMount').then(mountParams => { ... })
     */

  }, {
    key: 'once',
    value: function once(eventType) {
      var _this = this;

      var listener;
      var promise = new Promise(function (resolve, reject) {
        listener = _this.onMessage(eventType, resolve);
      });
      promise.then(function () {
        return _this.dropListener(listener);
      });
      return promise;
    }
    /**
     * @name - request
     * @param {string} eventType - event id for outgoing message
     * @param {string} responseType - event id for incoming message
     * @param {any} payload - body for outgoing message
     * @example
     * communicator.request('getUserData', 'gotUserData', { userId: 52314 }).then(userData => {}...})
     */

  }, {
    key: 'request',
    value: function request(eventType, responseType, payload) {
      var promise = this.once(responseType);
      this.sendMessage(eventType, payload);
      return promise;
    }
    /**
     * @name - dropListener
     * @param {any => void} listener
     */

  }, {
    key: 'dropListener',
    value: function dropListener(listener) {
      if (!this.listeners.has(listener)) return;
      window.removeEventListener('message', listener);
      this.listeners.delete(listener);
    }
  }, {
    key: '_getTargetWindow',
    value: function _getTargetWindow() {
      if (!!window.__stargate) {
        //puppeteer gateway for screenshot service.
        //it uses headless chrome api instead of iframes,
        //so it can't communicate using window.postMessage directly.
        return window.__stargate;
      }

      if (this.targetFrameId) {
        var iframe = document.getElementById(this.targetFrameId);
        return iframe && iframe.contentWindow;
      }

      return window.parent;
    }
  }]);

  return FrameCommunicator;
}();

exports.default = FrameCommunicator;

function calcIframeDepth() {
  if (window == window.top || window == window.parent) return 1;
  if (window.parent !== window.top) return 3;
  return 2;
}

module.exports = exports['default'];